/**
 * Fix for fejl med at produktside ikke vises ved windows accessibility kontrol sat til false ved motion
 */
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('motion-element').forEach((el) => {
      el.style.opacity = '';
      el.style.transform = '';
      el.style.visibility = '';
      el.classList.add('is-animated');
    });
  });
}

/**
 * Fix for fejl med at slider ikke vises ved windows accessibility kontrol sat til false ved motion
 */
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('motion-element').forEach((el) => {
      el.style.opacity = '';
      el.style.transform = '';
      el.style.visibility = '';
      el.classList.add('is-animated');
    });

    // Clear the slideshow's loading placeholder, which otherwise
    // never clears for reduced-motion visitors.
    document.querySelectorAll('[data-media-loading]').forEach((el) => {
      el.removeAttribute('data-media-loading');
    });
  });
}

// // ── Re-run triggers ──────────────────────────────────────────────────────────

// document.addEventListener('DOMContentLoaded', () => runSoldOutAppendix());

// // Standard Shopify section events
// document.addEventListener('shopify:section:load', () => runSoldOutAppendix());

// //Common theme AJAX filter completion events — add more if you find them
// [
//   'collection:rerender',
//   'collection:rerendered',
//   'facet:updated',
//   'facets:updated',
//   'filters:updated',
//   'collection:updated',
//   'theme:collection:updated',
// ].forEach(evt => document.addEventListener(evt, () => runSoldOutAppendix()));

// // ── Watch for the facet-form element completing its fetch ────────────────────
// // The facet form updates the URL via history.replaceState the instant a filter
// // or sort request is fired — before the section fetch resolves. Hooking both
// // History APIs lets the sold-out GraphQL request start in parallel with the
// // section fetch instead of waiting for `collection:rerendered` to fire after
// // it finishes, so the two network round-trips overlap instead of stacking.

// const _pushState = history.pushState.bind(history);
// history.pushState = function (...args) {
//   _pushState(...args);
//   // Small delay to let the theme finish swapping the DOM before we re-query
//   setTimeout(() => runSoldOutAppendix(), 100);
// };

// const _replaceState = history.replaceState.bind(history);
// history.replaceState = function (...args) {
//   _replaceState(...args);
//   runSoldOutAppendix();
// };

// // Also catch browser back/forward navigation
// window.addEventListener('popstate', () => {
//   setTimeout(() => runSoldOutAppendix(), 100);
// });

// // Catch History API navigation (AJAX filters that pushState)
// let lastSearch = location.search;
// const observer = new MutationObserver(async () => {
//   if (location.search !== lastSearch) {
//     lastSearch = location.search;
//     await runSoldOutAppendix();
//   }
// });
// observer.observe(document.getElementById('ProductsList') ?? document.body, {
//   childList: true,
//   subtree: false,
// });

// // The replaceState hook and the post-render `collection:rerendered` event
// // usually fire for the same filter state in close succession. Dedupe them by
// // filter-state key so we fire one GraphQL request per filter change, not two.
// let soldOutRequestKey = null;
// let soldOutRequestPromise = null;

// async function runSoldOutAppendix() {
//   const container = document.getElementById('SoldOutAppendix');
//   if (!container) return;

//   const key = `${container.dataset.collectionHandle}|${location.search}`;

//   if (soldOutRequestKey === key && soldOutRequestPromise) {
//     await soldOutRequestPromise;
//     return;
//   }

//   soldOutRequestKey = key;
//   soldOutRequestPromise = fetchSoldOutAppendix(container.dataset.collectionHandle, key);
//   await soldOutRequestPromise;
// }

// // async function fetchSoldOutAppendix(handle, requestKey) {
// //   // ── Parse active filters from the URL ──────────────────────────────────────
// //   const params = new URLSearchParams(location.search);

// //   // Collect product_type filters  (filter.p.product_type=Makeup)
// //   const productTypes = params.getAll('filter.p.product_type');

// //   // Collect vendor filters  (filter.p.vendor=Loreal)
// //   const vendors = params.getAll('filter.p.vendor');

// //   // Collect tag filters  (filter.p.tag=sale)
// //   const tags = params.getAll('filter.p.tag');

// //   // Price range  (filter.v.price.gte / filter.v.price.lte)
// //   const priceMin = params.get('filter.v.price.gte');
// //   const priceMax = params.get('filter.v.price.lte');

// //   // ── Build Storefront API productFilters ────────────────────────────────────
// //   const productFilters = [];

// //   for (const t of productTypes) productFilters.push({ productType: t });
// //   for (const v of vendors)      productFilters.push({ productVendor: v });
// //   for (const t of tags)         productFilters.push({ tag: t });

// //   if (priceMin || priceMax) {
// //     const priceFilter = {};
// //     if (priceMin) priceFilter.min = parseFloat(priceMin);
// //     if (priceMax) priceFilter.max = parseFloat(priceMax);
// //     productFilters.push({ price: priceFilter });
// //   }

// //   // ── GraphQL — add filters + availability:false ─────────────────────────────
// //   // We always add availableForSale:false so we only get sold-out products.
// //   // The other filters mirror what the user selected.
// //   const activeFilters = [
// //     { available: false },
// //     ...productFilters,
// //   ];

// //   const query = `
// //     query SoldOut($handle: String!, $filters: [ProductFilter!]) {
// //       collection(handle: $handle) {
// //         products(first: 250, filters: $filters) {
// //           edges {
// //             node {
// //               id
// //               title
// //               handle
// //               vendor
// //               productType
// //               availableForSale
// //               featuredImage {
// //                 url
// //                 altText
// //                 width
// //                 height
// //               }
// //               priceRange {
// //                 minVariantPrice { amount currencyCode }
// //               }
// //               compareAtPriceRange {
// //                 minVariantPrice { amount currencyCode }
// //               }
// //             }
// //           }
// //         }
// //       }
// //     }`;

// //   const escapeHtml = (str) => String(str ?? '').replace(/[&<>"']/g, (c) => ({
// //     '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
// //   }[c]));

// //   const sampleCard = document.querySelector('#ProductsList .product-card');
// //   const sectionId =
// //     document.querySelector('[data-section-id]')?.dataset.sectionId ||
// //     document.querySelector('section[id^="shopify-section-"]')?.id.replace('shopify-section-', '') ||
// //     'sold-out';

// //   const i18n = {
// //     soldOut:      sampleCard?.querySelector('.f-badge--soldout')?.textContent.trim()                           || 'Sold out',
// //     quickView:    sampleCard?.querySelector('.product-card__quickview')?.getAttribute('aria-label')            || 'Quick view',
// //     typeLabel:    sampleCard?.querySelector('.product-card__type .visually-hidden')?.textContent.trim()        || 'Type:',
// //     vendorLabel:  sampleCard?.querySelector('.product-card__vendor .visually-hidden')?.textContent.trim()      || 'Vendor:',
// //     regularPrice: sampleCard?.querySelector('.f-price__regular .visually-hidden--inline')?.textContent.trim()  || 'Regular price',
// //     salePrice:    sampleCard?.querySelector('.f-price__sale .visually-hidden--inline')?.textContent.trim()     || 'Sale price',
// //   };

// //   const locale = document.documentElement.lang || 'en';
// //   const formatMoney = (amount, currencyCode) => {
// //     try {
// //       return new Intl.NumberFormat(locale, { style: 'currency', currency: currencyCode })
// //         .format(parseFloat(amount));
// //     } catch {
// //       return `${amount} ${currencyCode}`;
// //     }
// //   };

// //   try {
// //     const res = await fetch('/api/2026-01/graphql.json', {
// //       method: 'POST',
// //       headers: {
// //         'Content-Type': 'application/json',
// //         'X-Shopify-Storefront-Access-Token': 'a0b6a9bf71927cc5aceeaaf0fbbc2c40',
// //       },
// //       body: JSON.stringify({
// //         query,
// //         variables: { handle, filters: activeFilters },
// //       }),
// //     });

// //     if (!res.ok) throw new Error(`HTTP ${res.status}`);
// //     const { data, errors } = await res.json();
// //     if (errors) throw new Error(errors.map((e) => e.message).join(', '));

// //     // A newer filter change superseded this request while it was in flight —
// //     // the section that triggered it no longer reflects the current state.
// //     if (soldOutRequestKey !== requestKey) return;

// //     const container = document.getElementById('SoldOutAppendix');
// //     if (!container) return;

// //     const soldOut = data?.collection?.products?.edges ?? [];

// //     if (soldOut.length === 0) {
// //       container.innerHTML = '';
// //       return;
// //     }

// //     const imageWidths = [70, 140, 165, 355, 450, 535, 600];

// //     const buildSrcset = (url) => {
// //       if (!url) return '';
// //       const base = url.split('?')[0];
// //       const version = url.match(/[?&]v=([^&]+)/)?.[1];
// //       const vParam = version ? `v=${version}&` : '';
// //       return imageWidths.map((w) => `${base}?${vParam}width=${w} ${w}w`).join(', ');
// //     };

// //     const buildSrc = (url, width = 600) => {
// //       if (!url) return '';
// //       const base = url.split('?')[0];
// //       const version = url.match(/[?&]v=([^&]+)/)?.[1];
// //       const vParam = version ? `v=${version}&` : '';
// //       return `${base}?${vParam}width=${width}`;
// //     };

// //     const extractId = (gid) => gid?.split('/').pop() || '';

// //     container.innerHTML = soldOut
// //       .map(({ node: p }) => {
// //         const productId = extractId(p.id);
// //         const quickViewId = `QuickView-${productId}-${sectionId}`;
// //         const img = p.featuredImage;
// //         const price = p.priceRange?.minVariantPrice;
// //         const compareAt = p.compareAtPriceRange?.minVariantPrice;
// //         const onSale = compareAt && parseFloat(compareAt.amount) > parseFloat(price?.amount ?? 0);

// //         const priceHtml = onSale
// //           ? `<div class="f-price f-price--left f-price--on-sale">
// //                <div class="f-price__regular">
// //                  <span class="visually-hidden visually-hidden--inline">${escapeHtml(i18n.regularPrice)}</span>
// //                  <span class="f-price-item f-price-item--regular">${escapeHtml(formatMoney(price.amount, price.currencyCode))}</span>
// //                </div>
// //                <div class="f-price__sale">
// //                  <span class="visually-hidden visually-hidden--inline">${escapeHtml(i18n.salePrice)}</span>
// //                  <span class="f-price-item f-price-item--sale">${escapeHtml(formatMoney(price.amount, price.currencyCode))}</span>
// //                  <span class="visually-hidden visually-hidden--inline">${escapeHtml(i18n.regularPrice)}</span>
// //                  <span class="f-price-item f-price-item--regular"><s>${escapeHtml(formatMoney(compareAt.amount, compareAt.currencyCode))}</s></span>
// //                </div>
// //              </div>`
// //           : `<div class="f-price f-price--left">
// //                <div class="f-price__regular">
// //                  <span class="visually-hidden visually-hidden--inline">${escapeHtml(i18n.regularPrice)}</span>
// //                  <span class="f-price-item f-price-item--regular">${escapeHtml(formatMoney(price?.amount ?? 0, price?.currencyCode ?? 'DKK'))}</span>
// //                </div>
// //              </div>`;

// //         const imageHtml = img
// //           ? `<div class="media-wrapper product-card__image product-card__image--main loaded" style="--aspect-ratio: 1/1">
// //                <img
// //                  src="${escapeHtml(buildSrc(img.url))}"
// //                  alt="${escapeHtml(img.altText ?? p.title)}"
// //                  srcset="${escapeHtml(buildSrcset(img.url))}"
// //                  width="${img.width || 600}"
// //                  height="${img.height || 600}"
// //                  loading="lazy"
// //                  fetchpriority="low"
// //                  class="motion-reduce loaded"
// //                  sizes="(max-width: 767px) calc((100vw - 38px) / 2), (max-width: 1279px) calc((100vw - 90px) / 3), calc(1300px / 4)"
// //                  is="image-lazy">
// //              </div>`
// //           : `<div class="product-card__image product-card__image--main" style="--aspect-ratio: 1/1"></div>`;

// //         const productTypeHtml = p.productType
// //           ? `<p class="product-card__type text-sm m-0" title=" ${escapeHtml(p.productType)}">
// //                <span class="visually-hidden">${escapeHtml(i18n.typeLabel)}</span>
// //                <a class="reversed-link" href="/collections/${escapeHtml(p.productType.toLowerCase().replace(/\s+/g, '-'))}" title="${escapeHtml(p.productType)}">${escapeHtml(p.productType)}</a>
// //              </p>` : '';

// //         const vendorHtml = p.vendor
// //           ? `<p class="product-card__vendor text-sm m-0">
// //                <span class="visually-hidden">${escapeHtml(i18n.vendorLabel)}</span>
// //                ${escapeHtml(p.vendor)}
// //              </p>` : '';

// //         return `
// //           <div class="f-column card">
// //             <div class="product-card product-card-style-standard sold-out-card"
// //                  data-product-id="${escapeHtml(productId)}"
// //                  data-product-vendor="${escapeHtml(p.vendor ?? '')}"
// //                  data-product-available="false">
// //               <div class="product-card__wrapper h-full">
// //                 <div class="product-card__image-wrapper product-card__image-wrapper--main-only color-scheme-1 bg-none">
// //                   <a href="/products/${escapeHtml(p.handle)}" aria-label="${escapeHtml(p.title)}" tabindex="-1">
// //                     <motion-element data-motion="zoom-out-sm" class="block">
// //                       ${imageHtml}
// //                     </motion-element>
// //                   </a>
// //                   <div class="product-card__badge">
// //                     <span class="f-badge f-badge--soldout" aria-hidden="true">Udsolgt</span>
// //                   </div>
// //                   <button
// //                     class="product-card__quickview btn btn--icon-circle btn--white no-js-hidden"
// //                     aria-label="${escapeHtml(i18n.quickView)}"
// //                     aria-controls="${escapeHtml(quickViewId)}"
// //                     aria-haspopup="dialog">
// //                     <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation"
// //                          viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
// //                          stroke-linecap="round" stroke-linejoin="round"
// //                          class="icon icon-magnifying-glass icon--large">
// //                       <path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z"/>
// //                       <path d="M16.4434 16.4453L20.9997 21.0016"/>
// //                     </svg>
// //                   </button>
// //                 </div>
// //                 <div class="product-card__info text-left">
// //                   ${vendorHtml}
// //                   ${productTypeHtml}
// //                   <h3 class="product-card__title text-pcard-title">
// //                     <a class="reversed-link" href="/products/${escapeHtml(p.handle)}">${escapeHtml(p.title)}</a>
// //                   </h3>
// //                   ${priceHtml}
// //                 </div>
// //               </div>
// //             </div>
// //           </div>`;
// //       })
// //       .join('');

// //   } catch (err) {
// //     console.error('Sold-out fetch failed:', err);
// //     if (soldOutRequestKey === requestKey) {
// //       const container = document.getElementById('SoldOutAppendix');
// //       if (container) container.innerHTML = '';
// //     }
// //   }
// // }

// window.addEventListener('load', function(){
//   /*var a_tags = document.getElementsByTagName('a');
//   for (var i = 0; i < a_tags.length; i++) {
//       if (a_tags[i].href.includes('/collections/') && !a_tags[i].href.includes('/products/')) {
//           if (!a_tags[i].href.includes('filter.v.availability')) {
//               a_tags[i].href += (a_tags[i].href.includes('?') ? '&' : '?') + 'filter.v.availability=1';
//           }
//       }
//   }*/
// })
